module.exports = __webpack_public_path__ + "static/media/lajitoufangchu.824f7d42.png";